import React, { Component } from "react";
import { Row, Col, Card, Button, Steps, Popover } from "antd";
import Category from "../../components/CategoriesCard";
import ShippingCost from "../../components/ShpingCost";
import CatalogCard from "../../components/catalogCard";
import { Store } from "../../store";
import { connect } from "react-redux";
import { CatalogAction } from "../../store/actions";
import General_Info from "../../components/generalInfo";
import RMX from "../../assets/images/b-RMX-1.png";
import TextInput from "../../components/input/TextInput";
import SubcriptionCardImg from "../../assets/images/subcription-card.png";
import "./Styles.css";

class Subscription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isClose: false,
      isOpenModal: false,
      filters: {
        order: "asc",
        page: 1,
        per_page: 12,
        column: "name",
        category_id: 1,
        // totalCount: 0,
        // currentCount: 0,
        // total_pages: 0,
        status: "active",
      },
      categoryName: "Standard Products",

      shipingprice: {
        am_charges: "0.0",
        pm_charges: "0.0",
      },
      price: "",
    };
  }

  abc = (key) => {
    this.setState({
      filters: {
        ...this.state.filters,
        category_id: key.id,
      },
      categoryName: key.name,
    });
  };

  render() {
    if (this?.props?.location?.state?.fromCustom) {
      return <General_Info />;
    }
    const { Step } = Steps;
    const customDot = (dot, { status, index }) => (
      <Popover
        content={
          <span>
            step {index} status: {status}
          </span>
        }
      >
        {dot}
      </Popover>
    );
    return (
      <Row justify="center">
        <Col xl={20} lg={20} xs={22} sm={22} md={22}>
          <Row>
            <Col
              xl={24}
              lg={24}
              xs={22}
              sm={22}
              md={24}
              style={{
                padding: "15px",
                justifyContent: "start",
                display: "flex",
                marginTop: "20px",
              }}
            >
              <img
                src={RMX}
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  backgroundRepeat: "no-repeat",
                  top: "-20px",
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col
              xl={24}
              lg={24}
              xs={24}
              sm={24}
              md={24}
              className="onhandle-mscreen"
              style={{ marginTop: "25px", marginBottom: "30px" }}
            >
              <Steps current={this.props.count} progressDot={customDot}>
                <Step title="Register" />
                <Step title="Create Profile" />
                <Step title="Add your plant" />
                <Step title="Personlize" />
                <Step title="Build Catalog" />
                <Step title="Subscription" />
              </Steps>
            </Col>
          </Row>
          <Row>
            <Col>
              <h2 className="text-left catalog-heading">
                Subscription Payment
              </h2>
            </Col>
          </Row>
          <Row>
            <Col
              xl={24}
              lg={24}
              xs={24}
              sm={24}
              md={24}
              style={{ marginBottom: "30px" }}
            >
              <Row>
                <Col
                  xl={10}
                  lg={10}
                  xs={24}
                  sm={24}
                  md={24}
                  className="card-padding"
                >
                  <Card className="card-height">
                    <Col>
                      <span className="text-center teal-text-dollar">$</span>
                      <span className="text-center  payment-data-number">
                        1500
                      </span>
                      <span className="text-center payment-data-text">
                        /month
                      </span>
                    </Col>
                    <Col>
                      <h4 className="text-center payment-plan-heading">
                        Basic Plan
                      </h4>
                    </Col>
                    <Col>
                      <p className="text-center ">
                        We've created Stripe Connect for exactly these use
                        cases. With Stripe Connect, you can accept payments for
                        your users without being involved in the flow.
                      </p>
                    </Col>
                  </Card>
                </Col>
                <Col xl={14} lg={14} xs={24} sm={24} md={24}>
                  <Row>
                    <Col
                      span={24}
                      className="text-left catalog-heading-register"
                    >
                      <img
                        src={SubcriptionCardImg}
                        width="70"
                        height="50"
                        alt="#"
                      />
                      <span style={{ padding: "15px" }}>Card Details</span>
                    </Col>
                  </Row>
                  <Row gutter={[0, 20]}>
                    <Col
                      xl={20}
                      lg={20}
                      xs={24}
                      sm={24}
                      md={24}
                      style={{ marginTop: "-35px" }}
                    >
                      <Col span={24}>
                        <TextInput label="Card Holder’s Name" required />
                      </Col>
                      <Col span={24}>
                        <TextInput label="Card Number" required />
                      </Col>
                      <Col span={24}>
                        <Row gutter={[10, 0]}>
                          <Col span={12}>
                            <TextInput label="Expiry Month" required />
                          </Col>
                          <Col span={12}>
                            <TextInput label="Expiry Year" required />
                          </Col>
                        </Row>
                      </Col>
                      <Col span={24}>
                        <TextInput label="CVC" required />
                      </Col>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row justify="end">
                <Col
                  xl={4}
                  lg={4}
                  xs={24}
                  sm={24}
                  md={6}
                  style={{ marginTop: "20px" }}
                >
                  <Button
                    style={{
                      backgroundColor: "#ff9800 ",
                      color: "#fff",
                      width: "100%",
                      border: "none",
                    }}
                    // onClick={() => this.props.history.push('/signin')}
                  >
                    Continue
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    // products: store.CatalogReducer.products,
    // metaData: store.CatalogReducer.metaData,
    // categories: store.CatalogReducer.categories,
    // shipingprice: store.CatalogReducer.shipingprice,
    // basemixData: store.CatalogReducer.basemixData,
    // isLoadingCategory: store.CatalogReducer.isLoadingCategorey,
    // isLoading: store.CatalogReducer.isLodading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // getCategories: (params) => dispatch(CatalogAction.getCategoriesReq(params)),
    // getProducts: (params, isTrue) =>
    //   dispatch(CatalogAction.getProductReq(params, isTrue)),
    // updateShippingCost: (value, id) =>
    //   dispatch(CatalogAction.updateShipingCostReq(value, id)),
    // getShippingCost: () => dispatch(CatalogAction.getShipingCostReq()),
    // postShippingCost: (payload) =>
    //   dispatch(CatalogAction.postShippingCostReq(payload)),
    // updateProduct: (value, id, active) =>
    //   dispatch(CatalogAction.updateProductReq(value, id, active)),
    // postProduct: (payload) => dispatch(CatalogAction.postProductReq(payload)),
    // basemixdata: (params) =>
    //   dispatch(CatalogAction.getBasemixCategoriesReq(params)),
    // getbasemixes: (params) => dispatch(CatalogAction.getBasemixesReq(params)),
    // getadditives: (params) => dispatch(CatalogAction.getAdditivesReq(params)),
    // getbasemixesCategories: (params) =>
    //   dispatch(CatalogAction.getBasemixesCategoriesReq(params)),
    // getTemplate: (params) => dispatch(CatalogAction.getTemplateReq(params)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Subscription);
